import React from 'react';
import { Button } from 'antd';
import { StyledFilterDrawer, DrawerSelect } from './styled';
import { COLORS } from '../../../constants/colors';

const { Option } = DrawerSelect;

const EVENT_STATUSES = {
  open: { label: 'Open' },
  locked: { label: 'Locked' },
  confirmed: { label: 'Confirmed' },
  completed: { label: 'Completed' },
  canceled: { label: 'Canceled' },
  rescheduled: { label: 'Rescheduled' },
};

const STAFFING_STATUSES = {
  fully_staffed: { label: 'Fully Staffed' },
  partially_staffed: { label: 'Partially Staffed' },
  unstaffed: { label: 'Unstaffed' },
};

const FilterDrawer = ({
  visible,
  onClose,
  statusFilter,
  setStatusFilter,
  staffingFilter,
  setStaffingFilter,
  onApply,
  onClear,
}) => {
  return (
    <StyledFilterDrawer
      title="Filter Events"
      placement="right"
      onClose={onClose}
      open={visible}
      width={340}
    >
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500, fontSize: 14, color: '#333' }}>
          Status
        </label>
        <DrawerSelect
          value={statusFilter}
          onChange={setStatusFilter}
          style={{ width: '100%' }}
          placeholder="All Statuses"
          allowClear
        >
          {Object.entries(EVENT_STATUSES).map(([key, val]) => (
            <Option key={key} value={key}>{val.label}</Option>
          ))}
        </DrawerSelect>
      </div>

      <div style={{ marginBottom: 24 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500, fontSize: 14, color: '#333' }}>
          Staffing
        </label>
        <DrawerSelect
          value={staffingFilter}
          onChange={setStaffingFilter}
          style={{ width: '100%' }}
          placeholder="All Staffing Levels"
          allowClear
        >
          {Object.entries(STAFFING_STATUSES).map(([key, val]) => (
            <Option key={key} value={key}>{val.label}</Option>
          ))}
        </DrawerSelect>
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <Button
          onClick={onClear}
          style={{ flex: 1, height: 40, borderRadius: 8 }}
        >
          Clear
        </Button>
        <Button
          type="primary"
          onClick={onApply}
          style={{
            flex: 1,
            height: 40,
            borderRadius: 8,
            background: COLORS.$primaryBlue,
            borderColor: COLORS.$primaryBlue,
          }}
        >
          Apply
        </Button>
      </div>
    </StyledFilterDrawer>
  );
};

export default FilterDrawer;
